import Vue from 'vue'
import VueRouter from 'vue-router'
import LivingImages from '../views/LivingImages.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'home',
    component: LivingImages
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
